/**
 * Configuration Map for 20 Distinct Corporate Styles
 */

export const VARIANT_CONFIG: Record<string, any> = {
    // 1-5: The "Corp" Series (Modern Corporate)
    'corp-alpha':   { header: 'split-hero', font: 'sans', accent: 'brand', bg: 'white', table: 'minimal', density: 'normal' },
    'corp-beta':    { header: 'sidebar-left', font: 'sans', accent: 'dark', bg: 'slate-50', table: 'striped', density: 'compact' },
    'corp-gamma':   { header: 'centered-classic', font: 'serif', accent: 'brand', bg: 'white', table: 'bordered', density: 'spacious' },
    'corp-delta':   { header: 'banner-top', font: 'sans', accent: 'brand', bg: 'white', table: 'clean', density: 'normal' },
    'corp-epsilon': { header: 'minimal-grid', font: 'mono', accent: 'black', bg: 'white', table: 'grid', density: 'compact' },

    // 6-10: The "Corp" Series (Cont.)
    'corp-zeta':    { header: 'hero-block', font: 'sans', accent: 'brand', bg: 'zinc-50', table: 'minimal', density: 'normal' },
    'corp-eta':     { header: 'sidebar-right', font: 'sans', accent: 'slate', bg: 'white', table: 'clean', density: 'compact' },
    'corp-theta':   { header: 'classic-row', font: 'serif', accent: 'brand', bg: 'stone-50', table: 'classic', density: 'spacious' },
    'corp-iota':    { header: 'asymmetric', font: 'sans', accent: 'brand', bg: 'white', table: 'modern', density: 'normal' },
    'corp-kappa':   { header: 'gradient-top', font: 'sans', accent: 'white', bg: 'white', table: 'clean', density: 'normal' },

    // 11-14: The "Pro" Series (High-End Consulting)
    'pro-slate':    { header: 'dark-sidebar', font: 'sans', accent: 'slate', bg: 'white', table: 'modern', density: 'compact' },
    'pro-obsidian': { header: 'dark-header', font: 'sans', accent: 'black', bg: 'white', table: 'bold', density: 'normal' },
    'pro-ivory':    { header: 'minimal-center', font: 'serif', accent: 'gold', bg: 'ivory', table: 'elegant', density: 'spacious' },
    'pro-navy':     { header: 'split-hero-navy', font: 'sans', accent: 'navy', bg: 'white', table: 'striped', density: 'normal' },

    // 15-16: Finance Specific
    'finance-prime': { header: 'data-heavy', font: 'sans', accent: 'brand', bg: 'white', table: 'grid', density: 'compact' },
    'finance-elite': { header: 'classic-finance', font: 'serif', accent: 'black', bg: 'white', table: 'bordered', density: 'compact' },

    // 17-18: Consulting
    'consult-apex':  { header: 'geometric-header', font: 'sans', accent: 'brand', bg: 'white', table: 'clean', density: 'spacious' },
    'consult-zenith':{ header: 'vertical-accent', font: 'sans', accent: 'brand', bg: 'slate-50', table: 'modern', density: 'normal' },

    // 19-20: Agency
    'agency-vogue':  { header: 'artistic-hero', font: 'sans', accent: 'black', bg: 'white', table: 'minimal', density: 'spacious' },
    'agency-aura':   { header: 'soft-gradient', font: 'sans', accent: 'brand', bg: 'white', table: 'clean', density: 'normal' },
};